import { LoadingTypography } from '@modules/common/components/LoadingTypography';
import { DEFAULT_ANOMALY_THRESHOLD } from '@modules/quantify/constants';
import {
  useFetchMeasuredAsCriteria,
  useGetSelectedGroupByOption,
} from '@modules/quantify/hooks';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Box, CardContent } from '@mui/material';
import { useTheme } from '@mui/system';
import {
  EqlFieldValueType,
  ObjectType,
  QuantifyVisualisationType,
} from 'generated/graphql';
import { FieldNames } from 'v2/core/entities/fields';
import { trackQuantifyTemplatesEvent } from './utils';

export const TopAnomalousReasons = () => {
  const theme = useTheme();
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);

  const { isLoading, selectedGroupByOption: reasonOption } =
    useGetSelectedGroupByOption(FieldNames.Reason);
  const { criteriaList } = useFetchMeasuredAsCriteria({
    field: reasonOption,
    fetchPolicy: 'cache-first',
  });

  const onClick = () => {
    const measuredAsCriteria = criteriaList.find((criteria) => {
      return (
        criteria.objectType === ObjectType.Feedback &&
        criteria.valueType === EqlFieldValueType.None
      );
    });

    dispatch({
      type: QuantifyActionType.SET_QUERY,
      payload: {
        groupByField: reasonOption,
        formulaQuery: {
          criteria: measuredAsCriteria,
        },
        shouldShowAnomalies: true,
        anomalyThreshold: DEFAULT_ANOMALY_THRESHOLD,
        visualisationType: QuantifyVisualisationType.Trend,
      },
    });

    trackQuantifyTemplatesEvent({
      eventName: 'Quantify Templates - "Top anomalous Reasons" clicked',
    });
  };

  return (
    <CardContent
      onClick={onClick}
      sx={{
        pointerEvents: isLoading ? 'none' : 'auto',
      }}
    >
      <LoadingTypography variant="subtitle2" isLoading={isLoading}>
        Top anomalous{' '}
        <Box component="span" color={theme.palette.secondary.main}>
          Reasons
        </Box>
      </LoadingTypography>
    </CardContent>
  );
};
